import {Component, ElementRef, HostListener, Inject, OnInit, ViewChild} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Metrika } from 'ng-yandex-metrika';
import { Message } from 'primeng/components/common/message';

import {
  AccountService,
  CategoryService,
  CookbookService, CookieService, IntroService,
  LandingService,
  PopupService, RestService,
  SpinnerService,
  AuthorizationDialogType
} from './shared/services';

import {
  HtmlHelper,
  AppConfig, Configuration
} from '@app/shared/shared.module';
import {UserRequest} from '@app/shared/models';
import {DOCUMENT} from '@angular/platform-browser';
import {MessageTypeCodes, PopupMessageSummaries, PopupMessageTypes} from '@app/shared/dictionaries';
import {timer} from 'rxjs/observable/timer';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/interval';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public Config: Configuration;

  constructor(
    private router: Router,
    private metrika: Metrika,
    public popupService: PopupService,
    private landingService: LandingService,
    private accountService: AccountService,
    private categoriesService: CategoryService,
    private cookbookService: CookbookService,
    private spinnerService: SpinnerService,
    private cookieService: CookieService,
    public restService: RestService,
    private introService: IntroService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.Config = AppConfig.config;
  }
  isMobile: boolean;
  isTablet: boolean;
  windowWidth: number = window.innerWidth;
  windowHeight: number = window.innerHeight;
  title = 'app';
  msgs: Message[] = [];
  separatedMsgs: Message[] = [];
  separatedMsgsTime: number;
  browserIsOld = false;
  user = new UserRequest();
  isLogged: boolean;
  isShowNotifyPopup = false;
  authorizationPopupDisplayed: boolean;
  authorizationPopupText: string;
  loginPopupDisplayed: boolean;
  signupPopupDisplayed: boolean;
  restorationPopupDisplayed: boolean;
  confirmationEmailHasbeenSend: boolean;
  emailConfirmed: boolean;
  passwordRep = '';
  blockedByLoading: boolean;
  interval;
  msgTime: number;
  introStage: boolean;
  stageIntro = 0;
  loaderTimeout = null;

  @ViewChild('signinEmail') signinLogin: ElementRef;
  @ViewChild('signinPassword') signinPassword: ElementRef;
  @ViewChild('registerEmail') registerLogin: ElementRef;
  @ViewChild('registerPassword') registerPassword: ElementRef;
  @ViewChild('registerPasswordRep') registerPasswordRep: ElementRef;
  @ViewChild('restorationEmail') restorationLogin: ElementRef;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowWidth = event.target.innerWidth;
    this.isMobile = HtmlHelper.checkMobile(this.windowWidth);
    this.isTablet = HtmlHelper.checkTablet(this.windowWidth);
    this.windowHeight = event.target.innerHeight;
  }

  ngOnInit() {
    this.isMobile = HtmlHelper.checkMobile(this.windowWidth);
    let prevPath = window.location.pathname;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const newPath = window.location.pathname;
        this.metrika.hit(newPath, {
          referer: prevPath,
        }, 0);
        prevPath = newPath;
      }
    });

    this.spinnerService.getSubscriptionToLodaerBlockUI().then(x => {
      if (x) {
        this.spinnerService.getStateForSearch().subscribe(y => {
          if (y !== null && y !== undefined) {
            if (this.loaderTimeout) clearTimeout(this.loaderTimeout);
            this.loaderTimeout = setTimeout(() => {
              this.blockedByLoading = y;
            }, 100);
          }
        });
      }
    });

    this.popupService.getSubscription().subscribe(message => {
      if (message) {
        if (message.duration) {
          this.separatedMsgsTime = message.duration;
          this.separatedMsgs.push(message);
        } else {
          this.msgTime = message.severity === PopupMessageTypes.Error ? this.Config.msgsErrorTime : this.Config.msgsSuccessTime;
          this.msgs.push(message);
        }
      }
    });

    this.popupService.getClearSubscription().subscribe(() => {
      this.msgs.splice(0);
      this.separatedMsgs.splice(0);
    });

    this.landingService.getLoginDialogSub().subscribe(flag => this.loginPopupDisplayed = flag);
    this.landingService.getAuthorizationDialogSub().subscribe( (flagObg: AuthorizationDialogType)  => {
      this.authorizationPopupDisplayed = flagObg.showStatus;
      this.authorizationPopupText = flagObg.textField;
    });
    this.landingService.getSignupDialogSub().subscribe(flag => {
      this.signupPopupDisplayed = flag;
    });
    this.landingService.getEmailSendDialogSub().subscribe(flag => this.confirmationEmailHasbeenSend = flag);
    this.landingService.getBrowserCheckDialog().subscribe(flag => this.browserIsOld = flag);
    this.landingService.getCurrentUser().subscribe(user => {
      if (user) {
        this.user = user;
      }
    });
    this.landingService.getLoginSub().subscribe(user => {
      if (user && user.Email && user.HPassword) {
        this.user = user;
        this.login();
      }
    });
    this.accountService.getConfirm().subscribe(flag => {
      if (flag) {
        this.emailConfirmed = flag;
        this.accountService.emailConfirmed.next(false);
      }
    });
    this.accountService.showNotifyPopupSub().subscribe( flag => {
      if (flag) {
        this.setListenerForCookie();
      }
    });

    this.accountService.showSignUpDialog().subscribe( bool => {
      if (bool) {
        this.accountService.isAuthenticated().then(result => {
          this.isLogged = (result.isLoggedIn && !result.isAnonymous);
          this.showAuthorizationInterval();
        });
      }
    });

    this.introService.getIntroStage().subscribe(stage => {
      this.introStage = stage <= 0;
    });
  }

  showAuthorizationInterval(secondTime?: boolean) {
    this.interval = setInterval(() => {
      if (!this.isLogged && !this.authorizationPopupDisplayed && !this.loginPopupDisplayed && !this.signupPopupDisplayed) {
        this.openAuthorizationDialog(true);
        clearInterval(this.interval);
      }
    }, secondTime ? AppConfig.config.AuthorizationShowTime : AppConfig.config.AuthorizationShowTimeFirst);
  }

  checkForEnter(event): boolean {
    return event.keyCode === 13;
  }

  login(event?: any) {
    if (event && !this.checkForEnter(event)) {
      return;
    }
    if (!HtmlHelper.checkValidity(this.user.Email, this.signinLogin)) {
      return;
    }
    if (!HtmlHelper.checkValidity(this.user.HPassword, this.signinPassword)) {
      return;
    }

    this.accountService.logIn(this.user).then(
        userData => {
          if (userData !== null && userData.Result !== null) {

            if (userData.Result.ReturnCode > 0) {
              this.user = new UserRequest();
              this.landingService.changeUser(this.user);
              this.loginPopupDisplayed = false;
              this.categoriesService.get().subscribe();
              this.cookbookService.get();
              this.closePopups();
              let redirectUrl = '/main/recipes/list';
              if (this.accountService.returnUrl) {
                redirectUrl = this.accountService.returnUrl;
                this.accountService.returnUrl = null;
              }
              this.router.navigateByUrl(redirectUrl);
              window.location.reload();
            }
            return;
          }
        }
    );
  }

  onMessageHover() {
    if (!this.isMobile) {
      this.msgs.splice(0, 1);
    }
  }

  onActivate(event) {
    window.scroll(0, 0);
  }

  setHiddenClassToBody(status) {
    (status) ? this.document.body.classList.add('hidden') : this.document.body.classList.remove('hidden');
  }

  closePopups() {
    this.authorizationPopupDisplayed = false;
    this.restorationPopupDisplayed = false;
    this.confirmationEmailHasbeenSend = false;
    this.emailConfirmed = false;
    this.landingService.toggleSignupDialog(false);
    this.landingService.toggleLoginDialog(false);
    this.landingService.toggleEmailSendDialog(false);
    this.landingService.toggleBrowserWarning(false);
  }

  goToList() {
    this.router.navigate([`/main/recipes/list`]);
  }

  openAuthorizationDialog(state) {
    this.landingService.toggleLoginDialog(false);
    this.landingService.toggleSignupDialog(false);
    this.restorationPopupDisplayed = false;
    this.landingService.toggleAuthorizationDialog(true, state);
  }

  openSignupDialog() {
    this.user = new UserRequest();
    this.restorationPopupDisplayed = false;
    this.landingService.toggleAuthorizationDialog(false);
    this.landingService.toggleLoginDialog(false);
    this.landingService.toggleSignupDialog(true);
  }

  openLoginDialog() {
    this.user = new UserRequest();
    this.authorizationPopupDisplayed = false;
    this.restorationPopupDisplayed = false;
    this.landingService.toggleSignupDialog(false);
    this.landingService.toggleLoginDialog(true);
  }

  openEmailSendDialog() {
    this.confirmationEmailHasbeenSend = true;
    this.landingService.toggleSignupDialog(false);
    this.landingService.toggleLoginDialog(false);
    this.landingService.toggleEmailSendDialog(true);
  }


  openRestorationDialog() {
    this.user = new UserRequest();
    this.authorizationPopupDisplayed = false;
    this.signupPopupDisplayed = false;
    this.loginPopupDisplayed = false;
    this.restorationPopupDisplayed = true;
  }

  replaceSpaces(event?: any) {
    const val = event.target.attributes['data-user'].value;
    if (this.user[val]) {
      this.user[val] = HtmlHelper.replaceString(this.user[val], ' ', '');
    }
  }

  register(event?: any) {
    if (event && !this.checkForEnter(event)) {
      return;
    }
    if (!HtmlHelper.checkValidity(this.user.Email, this.registerLogin)) {
      return;
    }
    const dogIndex = this.user.Email.indexOf('@');
    const dotIndex = this.user.Email.substr(dogIndex).indexOf('.');
    const lengthIndex = this.user.Email.substr(dogIndex).substr(dotIndex);
    if ((dogIndex === -1) || (dotIndex === -1) || (lengthIndex.length < 1)) {
      if (this.registerLogin.nativeElement) {
        this.registerLogin.nativeElement.setCustomValidity('Некорректный формат почты!');
        this.registerLogin.nativeElement.reportValidity();
      }
      return;
    }

    if (!HtmlHelper.checkValidity(this.user.HPassword, this.registerPassword)) {
      return;
    }

    if (!HtmlHelper.checkValidity(this.passwordRep, this.registerPasswordRep) || this.passwordRep !== this.user.HPassword) {
      if (this.registerPasswordRep.nativeElement) {
        this.registerPasswordRep.nativeElement.setCustomValidity('Пароли не совпадают!');
        this.registerPasswordRep.nativeElement.reportValidity();
      }
      return;
    }

    this.accountService.register(this.user).then(x => {
      if (x !== null) {
        this.user = new UserRequest();
        this.passwordRep = null;
        if (x.Result.ReturnCode > 0) {
          this.signupPopupDisplayed = false;
          if (x.Result.Message === 'OK') {
            this.popupService.clearMessages();
            this.openEmailSendDialog();
          }
          return;
        }

        this.showMessage(MessageTypeCodes.RegistrationError, x.Result.Message);
        return;
      }
      this.showMessage(MessageTypeCodes.RegistrationError, 'Ошибка отправки, пожалуйста попробуйте еще раз.');
      return;
    }, () => {
      this.showMessage(MessageTypeCodes.RegistrationError, 'Ошибка отправки, пожалуйста попробуйте еще раз.');
    });
  }

  showMessage(code: MessageTypeCodes, message: string) {
    let severity = '';
    let info = '';
    switch (code) {
      case MessageTypeCodes.RegistrationError:
        severity = PopupMessageTypes.Error;
        info = PopupMessageSummaries.Error;
        message = `Ошибка при регистрации! ${message}`;
        break;
      case MessageTypeCodes.Error:
        severity = PopupMessageTypes.Error;
        info = PopupMessageSummaries.Error;
        break;
      case MessageTypeCodes.Success:
        severity = PopupMessageTypes.Success;
        info = PopupMessageSummaries.Success;
        break;
      case MessageTypeCodes.RegistrationSuccess:
        severity = PopupMessageTypes.Success;
        info = PopupMessageSummaries.Success;
        message = message || 'Регистрация выполнена!';
        break;
      case MessageTypeCodes.SignInSuccess:
        severity = PopupMessageTypes.Success;
        info = PopupMessageSummaries.Success;
        message = 'Вход выполнен!';
        break;
      default:
        severity = PopupMessageTypes.Info;
        info = PopupMessageSummaries.Success;
        break;
    }

    this.popupService.showMessage({ severity: severity, summary: info, detail: message });
  }

  loginWithFacebook(): void {
    this.accountService.logInFb()
        .then(() => {
          this.detectAuthClosePromise();
        });
  }

  loginWithVk() {
    this.accountService.logInVk()
        .then(() => {
          this.detectAuthClosePromise();
        });
  }

  loginWithOk() {
    this.accountService.logInOk()
        .then(() => {
          this.detectAuthClosePromise();
        });
  }

  loginWithGoogle() {
    this.accountService.logInGoogle()
        .then(() => {
          this.detectAuthClosePromise();
        });
  }

  detectAuthClosePromise() {
    const timerSubscription = timer(0, 2000).subscribe(() => {
      this.accountService.isAuthenticated(true).then(result => {
        if (result.isLoggedIn && !result.isAnonymous) {
          timerSubscription.unsubscribe();
          let redirectUrl = '/main/recipes/list';
          if (this.accountService.returnUrl) {
            redirectUrl = this.accountService.returnUrl;
            this.accountService.returnUrl = null;
          }
          window.location.pathname = redirectUrl;
        }
      });
    });
  }

  restorePassword(event) {
    if (event && !this.checkForEnter(event)) {
      return;
    }
    if (!HtmlHelper.checkValidity(this.user.Email, this.restorationLogin)) {
      return;
    }

    this.accountService.passwordRestore(this.user.Email).then(resp => {
      if (resp.Result.ReturnCode > 0) {
        this.showMessage(MessageTypeCodes.Success, `Сообщение с паролем отправлено по указанному адресу`);
        this.closePopups();
      }
    });
  }

  setListenerForCookie() {
    const delay = 5000;
    const obsSub = Observable.interval(delay).subscribe(() => {
      if (this.cookieService.getCookie('isNotifyPop') === undefined && !this.isShowNotifyPopup && this.stageIntro === 0) {
        if (this.cookieService.getCookie('SessionId') === '-111') {
          obsSub.unsubscribe();
          return;
        }
        this.isShowNotifyPopup = true;
      }
    });
  }

  closeNotifyPopupToSub(redirect: boolean) {
    this.isShowNotifyPopup = false;
    this.cookieService.writeNotifyPopCookie(true, this.Config.NotifyCookiesLifetime);

    if (redirect) { this.router.navigateByUrl('/main/settings/tariff'); }
  }

  reloadPage() {
    window.location.reload(true);
  }

  gotToTarif() {
    this.router.navigateByUrl('/main/settings/tariff');
    this.restService.closePopupTarif();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts